import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { formatNumber2 } from "utils/currencyFormat";
import { ModalPhiHangKy } from "./ModalPhiHangKy";

export const BtnPhiHangKy = ({ item, Type }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      {item.OtheFeeHangKy !== null && item.OtheFeeHangKy !== 0 ? (
        <>
          <a onClick={handleShow} href={() => false} className="blue btn-link">
            {formatNumber2(item.OtheFeeHangKy)}
          </a>
          {show && (
            <ModalPhiHangKy
              show={show}
              onHide={handleClose}
              paidId={item.PaidID}
              chovayId={item.ChoVayID}
              typeChoVay={Type}
            />
          )}
        </>
      ) : (<>0</>)}
    </>
  );
};
